// Function Overloading

import { Paths } from 'type-fest';

import { GetFieldType, getValue } from '@ocx/utils';

import { RuntimeConfig } from './app-config.types';
import { useConfigurationContext } from './useConfigurationContext';

export function useConfiguration(path?: undefined): { config: RuntimeConfig };
export function useConfiguration<TPath extends Paths<RuntimeConfig>>(path: TPath): GetFieldType<RuntimeConfig, TPath>;
export function useConfiguration(
  path?: string,
): { config: RuntimeConfig } | GetFieldType<RuntimeConfig, Paths<RuntimeConfig>> {
  const { config } = useConfigurationContext();

  // null is a valid configuration value
  if (path && getValue(config, path) === undefined) {
    throw new Error(`configuration does not have following path '${path}'`);
  }

  if (path) {
    return getValue(config, path) as GetFieldType<RuntimeConfig, Paths<RuntimeConfig>>;
  }
  return { config };
}
